import { render } from "./FullLatexEditor.vue?vue&type=template&id=f2a6dff0&scoped=true"
import script from "./FullLatexEditor.vue?vue&type=script&lang=js"
export * from "./FullLatexEditor.vue?vue&type=script&lang=js"

import "./FullLatexEditor.vue?vue&type=style&index=0&id=f2a6dff0&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2a6dff0"]])

export default __exports__